var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 475 475",
    style: {
      enableBackground: "new 0 0 475 475"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M237.5,0c-82.71,0-150,67.29-150,150c0,57.925,33.147,110.298,85,135.238V395c0,5.523,4.477,10,10,10h10v40 c0,5.523,4.477,10,10,10h25v20h20v-20h25c5.522,0,10-4.477,10-10v-40h10c5.522,0,10-4.477,10-10V285.238 c51.853-24.939,85-77.313,85-135.238C387.5,67.29,320.21,0,237.5,0z M262.5,435h-50v-30h50V435z M282.5,385h-10h-70h-10v-20h90 V385z M282.5,345h-90v-15h90V345z M288.565,269.605c-3.679,1.574-6.065,5.191-6.065,9.193V310h-90v-31.201 c0-4.002-2.387-7.619-6.065-9.193C138.483,249.086,107.5,202.138,107.5,150c0-71.682,58.317-130,130-130s130,58.318,130,130 C367.5,202.138,336.517,249.086,288.565,269.605z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.5,145h-56.618l45.014-69.567l-16.791-10.865l-55,85c-1.99,3.076-2.14,6.994-0.389,10.211 c1.751,3.218,5.121,5.221,8.784,5.221h59.242l-33.29,70.742l18.096,8.516l40-85c1.458-3.098,1.229-6.726-0.605-9.616 C279.109,146.751,275.924,145,272.5,145z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.5,
    y: 145,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.5,
    y: 145,
    width: 20,
    height: 20
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamp);
export default __webpack_public_path__ + "static/media/lamp.1689b69da9f23c749328f97396eab402.svg";
export { ForwardRef as ReactComponent };